import { Model, Collection } from '@/models/BaseModel';

import {
    equal,
    integer,
    min,
    required,
    string,
    email,
    boolean
} from 'vue-mc/validation';
import { UserType } from '@/services/LoginService';

export class Table extends Model {
    public options() {
        return {
            identifier: 'id'
        };
    }

    public defaults() {
        return {
            id: null,
            name: '',
            number_of_seats: 0,
            layout_x: 0,
            layout_y: 0,
            qr_code: '',
            beacon: '',
            type: 0
        };
    }

    public mutations() {
        return {
            id: (id: any) => Number(id) || null,
            name: String,
            number_of_seats: Number,
            layout_x: Number,
            layout_y: Number,
            qr_code: String,
            beacon: String,
            type: Number
        };
    }

    public validation() {
        return {
            id: integer.and(min(1)).or(equal(null)),
            name: string.and(required),
            number_of_seats: integer.and(required),
            layout_x: integer.and(required),
            layout_y: integer.and(required),
            qr_code: string,
            beacon: string,
            type: integer.and(min(1))
        };
    }

    public routes() {
        return {
            fetch: "tables/{id}",
            save: "tables",
            delete: "tables/{id}"
        };
    }
}

export class TableCollection extends Collection {
    public model() {
        return Table;
    }

    public defaults() {
        return {
            orderBy: 'name',
        };
    }

    public routes() {
        return {
            fetch: "tables",
        };
    }

    public fetchData() {
        return this.fetch();
    }
}

export enum TableType {
    Restaurant = 1,
    Website = 2,
    Flyer = 3
}
